// import { useEffect, useState } from 'react';
import avatarPlaceholder from '../../assets/images/avatar-placeholder.png';
interface AvatarProps {
    imageUrl: string;
    onClickHandler?: any;
    className?: any;
    size: string;
    avatarClassName?: string;
}

// const dummyData = "https://images.pexels.com/photos/1704488/pexels-photo-1704488.jpeg?auto=compress&cs=tinysrgb&w=30&h=30"
export default function Avatar({ imageUrl, onClickHandler, className, size }: AvatarProps) {
    // const [imgSrc, setImgSrc] = useState<any>(null);

    // useEffect(() => {
    //     const img = new Image();
    //     img.src = imageUrl;
    //     img.onload = () => setImgSrc(imageUrl);
    //     img.onerror = () => setImgSrc(avatarPlaceholder);
    // }, [imageUrl]);

    const getAvatarCardSize = () => {
        switch (size) {
            case 'sm':
                return "w-[32px] h-[32px]";
            case 'md':
                return "w-[55px] h-[55px]";
            case 'lg':
                return "";
            case 'xl':
                return "w-[92.03px] h-[92.03px]";
            default:
                return "w-[32px] h-[32px]";
        }
    };

    return (
        <div className={`avatardivWrap flex flex-wrap gap-1 ${className}`} onClick={onClickHandler}>
            <img src={imageUrl || avatarPlaceholder} className={`rounded object-contain object-center ${getAvatarCardSize()}`} alt='' />
        </div>
    );
};